
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OnDestroy, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './authentication/auth.service';
import { SharedAuthenticationService } from './authentication/shared/shared-authentication.service';
import { AppSettingsService } from './services/common/appsettings.service';
import { ConstantService } from './services/common/constant.service';
import { UserSessionService } from './services/identity';
import { ThemeModelV2 } from './services/organization';
import { ThemingService } from './services/common/theming.service';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  template: `<router-outlet/>`,
})
export class App implements OnInit, OnDestroy {
  private router = inject(Router);
  private translate = inject(TranslateService);
  authService = inject(AuthService);
  private title = inject(Title);
  private sharedService = inject(SharedAuthenticationService);
  private constantService = inject(ConstantService);
  appSettings = inject(AppSettingsService);
  private cookieService = inject(CookieService);
  private userSessionService = inject(UserSessionService);
  private idle = inject(Idle);
  private themingService = inject(ThemingService);

  loadingLang: boolean = true;
  themeModel: ThemeModelV2 = {};

  private activeTimer: Subscription;

  ngOnDestroy(): void {
    this.activeTimer.unsubscribe();
  }

  async ngOnInit() {

    this.configureIdle();
    let user = await this.authService.getUser(false);
    if (user && window.location.pathname.indexOf('/auth/logout') == -1) {      
      this.authService.getUserPostLoginStatus(true);
    }

    // handle admin toggling for reload behavior
    if (this.cookieService.check('loadStatus')) {
      this.appSettings.settings.adminMenu = true;
      this.cookieService.delete('loadStatus');
    }
    window.addEventListener('beforeunload', () => {
      if (this.appSettings.settings.adminMenu) {
        const expires = new Date();
        expires.setSeconds(expires.getSeconds() + 5);
        this.cookieService.set('loadStatus', 'true', expires);
      }
    });
    // end handle admin toggling for reload behavior

    await this.getLocalSettings();
    this.title.setTitle(this.constantService.showOrgName);
    await this.themingService.getTheme();

    this.checkUri();
    ;
    this.activeTimer = interval(60 * 1000).subscribe(() => {
      if (!this.idle.isIdling()) {
        this.updateActive();
      }
    })
  }

  logout(): void {
    this.sharedService.delayedSignout();
  }

  checkUri(): void {
    if (environment.production) {
      let publicUrl = environment.publicUrl;
      if (publicUrl.startsWith('.')) {
        publicUrl = publicUrl.substring(1);
      }
      if (window.location.hostname.indexOf(publicUrl) == -1) {
        const orgName = this.constantService.getSubdomain();
        window.location.hostname = `${orgName}.${publicUrl}`;
      }
    }
  }

  private async getLocalSettings() {

    await this.authService.loadLanguages();

    if (window.location.pathname == '/') {
      this.authService.redirectUser();
    }

    this.loadingLang = false;
  }

  private configureIdle() {
    this.idle.setIdle(5 * 60);
    this.idle.setTimeout(8 * 60 * 60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.watch();
    this.idle.onIdleStart.subscribe(() => {

    });

    this.idle.onIdleEnd.subscribe(() => {
      this.updateActive();
    });

    this.idle.onTimeout.subscribe(() => {
      this.authService.signOut();
    });

  }

  private updateActive() {
    const orgId = this.authService.user?.profile.organizationId ?? this.authService.user?.profile.OrganizationId;
    if (this.authService.sessionId && orgId) {
      this.userSessionService.apiUserSessionUpdateLastActiveOrganizationIdUserIdSessionIdPut(orgId, Number(this.authService.id), this.authService.sessionId).subscribe(data => {
      });
    }
  }

  
}